import { Menu } from 'lucide-react';
import { ThemeToggle } from '../ui/theme-toggle';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="flex items-center justify-between p-4 bg-surface border-b border-border lg:hidden">
      <div className="flex items-center gap-3">
        <button onClick={onMenuClick} aria-label="Open navigation">
          <Menu size={20} />
        </button>
        <span className="font-semibold">FastAid OS</span>
      </div>
      <ThemeToggle compact />
    </header>
  );
}
